import React from 'react';

const Hero = () => {
  return (
    <div className="lil-relative lil-h-[1000px] md:lil-min-h-0  lg:lil-h-[800px] xl:lil-h-[600px]">
      <div
        className="lil-absolute lil-inset-0 lil-bg-cover lil-bg-center"
        style={{
          backgroundImage: 'url(https://www.toulouse.aeroport.fr/sites/default/files/styles/atb_xlarge/public/jpg/pluie-header_1756x800px.jpg?itok=RJ8uHITJ)'
        }}
      >
        <div className="lil-absolute lil-inset-0 lil-bg-black lil-bg-opacity-40"></div>
      </div>
      <div className="lil-relative lil-container lil-mx-auto lil-px-4 lil-py-16 lil-text-white lil-pt-32">
        <h1 className="lil-text-4xl lil-font-bold lil-mb-8 lil-mx-auto lil-max-w-7xl lil-leading-tight lil-font-cursive">
                On ne vous garantit pas des vacances parfaites
              </h1>
        <h2 className="lil-text-4xl lil-font-bold lil-mb-8 lil-mx-auto lil-max-w-7xl lil-leading-tight">
        Mais on vous y emmène en vol direct !
              </h2>
             

      {/* Promo Floating Div - Hidden on Mobile */}
      {/* <div className="lil-hidden lil-z-50 lg:lil-block lil-absolute lil-top-[50px]  lil-right-8 lil-max-w-md lil-bg-white lil-rounded-lg lil-shadow-xl lil-p-6 lil-animate-float">
        <div className="lil-flex lil-items-start lil-gap-4">
          <div className="lil-flex-shrink-0">
            <svg className="lil-w-8 lil-h-8 lil-text-[#E91E63]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 5l-3 3m0 0l-3-3m3 3V0" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l3-3 3 3" />
            </svg>
          </div>
          <div>
            <h3 className="lil-text-lg lil-font-semibold lil-text-gray-900 lil-mb-2"></h3>
            <p className="lil-text-gray-600 lil-text-sm">
              Testez notre panier multi-produits
              <br />
              <b>Parking &gt; Hotel &gt; Lounge</b>
              <br />
              Une fois sur l'onglet "Airport Parking" , Saisissez le code DEMO dans "voucher"
              
            </p>
          </div>
        </div>
      </div> */}
        <div id="App" className="lil-w-full lil-max-w-7xl lil-mx-auto lil-z-10 lil-text-black"></div>
      </div>
    </div>
  );
};

export default Hero; 